import { IconConfig } from "../types";

export const email: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 18.763 15.01",
  elements: [
    {
      type: 'path',
      fill: "currentColor",
      d: "M16.887 0H1.876A1.874 1.874 0 0 0 .009 1.876L0 13.134a1.88 1.88 0 0 0 1.876 1.876h15.011a1.88 1.88 0 0 0 1.876-1.876V1.876A1.88 1.88 0 0 0 16.887 0m0 13.134H1.876V3.753l7.505 4.691 7.505-4.691ZM9.382 6.567 1.876 1.876h15.011Z"
    }
  ] as const
}
